import { useGrowl } from "PFApp/use_growl";
import ConfirmModal from "PFComponents/confirm/confirm_modal";
import { useResponseErrors } from "PFCore/helpers/use_response_errors";
import { ApiRoute } from "PFCore/utilities/routes";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import { useActivityHistoryInvalidate } from "../history/hooks/use_activity_history_invalidate";

const RequestHelpModal = ({ activity, onClose }) => {
  const growl = useGrowl();
  const { t } = useTranslation("activities");
  const { getFirstError } = useResponseErrors();
  const invalidateHistory = useActivityHistoryInvalidate(activity.id);

  const handleClick = () =>
    $.ajax({
      url: ApiRoute(`/api/activities/${activity.id}/request_help`),
      // eslint-disable-next-line camelcase
      api_version: 2,
      method: "POST"
    }).then(
      () => {
        growl({ kind: "success", message: t("show.parts.helpRequested") });
        invalidateHistory();
        onClose();
      },
      (response) => {
        const error = getFirstError(response);
        growl({
          message: error || t("show.parts.unknownError"),
          kind: "error"
        });
      }
    );

  return (
    <ConfirmModal labelOK="Request help" handleOK={handleClick} handleClose={onClose}>
      <div style={{ padding: 20, textAlign: "center" }}>{t("show.parts.pleaseRequestHelp")}</div>
    </ConfirmModal>
  );
};

RequestHelpModal.propTypes = {
  activity: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
};

export default RequestHelpModal;
